<template>
  <div></div>
</template>

<script>
import { loadHcaptcha } from '../modules/hcaptcha';

export default {
  name: 'Hcaptcha',
  props: {
    sitekey: {type: String, required: true},
    size: {type: String, default: 'invisible'},
  },
  data() {
    return {widgetId: null};
  },
  created() {
    this.captchaApi = null;
    this.captchaReady = null;
    this.captchaDestroyed = false;
  },
  mounted() {
    this.prepare().catch(err => this.$emit('error', err));
  },
  beforeDestroy() {
    this.captchaDestroyed = true;
    if (this.captchaApi && this.widgetId !== null) {
      this.captchaApi.remove(this.widgetId);
    }
  },
  methods: {
    prepare() {
      if (!this.captchaReady) {
        this.captchaReady = loadHcaptcha().then(api => {
          if (this.captchaDestroyed) return;
          this.captchaApi = api;
          this.widgetId = api.render(this.$el, {
            sitekey: this.sitekey,
            size: this.size,
            callback: token => this.$emit('verify', token),
            'expired-callback': () => this.$emit('expired'),
            'error-callback': error => this.$emit('error', error),
          });
        }).catch(err => {
          this.captchaReady = null;
          throw err;
        });
      }
      return this.captchaReady;
    },
    execute() {
      return this.prepare().then(() => {
        if (!this.captchaDestroyed) this.captchaApi.execute(this.widgetId);
      });
    },
    reset() {
      if (this.captchaApi && this.widgetId !== null) {
        this.captchaApi.reset(this.widgetId);
      }
    },
  },
};
</script>
